// extracted by mini-css-extract-plugin
module.exports = {"textarea":"FormTextarea_textarea__4GO0x","textarea--invalid":"FormTextarea_textarea--invalid__A9ur6"};